import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const CenterWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0px 16px;
`

interface IActionButtonProps {
  $isDisabled: boolean
}

export const ActionButton = styled.div<IActionButtonProps>`
  cursor: ${props => (props.$isDisabled ? 'not-allowed' : 'pointer')};
  display: flex;
`

export const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${COLORS.secondaryDark};
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    display: none;
  }
`
